export const featuredArticles = [
  {
    id: '1',
    title: '某顶流男星深夜密会神秘女子，酒店共度8小时全程被拍',
    excerpt: '据知情人透露，两人已秘密交往半年之久，女方为圈外人士，家境优渥。当晚男方全副武装低调出行，仍被蹲守狗仔拍到高清画面...',
    category: '明星八卦',
    categorySlug: 'star-gossip',
    imageUrl: 'https://readdy.ai/api/search-image?query=Close-up%20of%20a%20smartphone%20screen%20displaying%20a%20blurred%20paparazzi-style%20night%20photo%20of%20a%20mysterious%20figure%20entering%20a%20luxury%20hotel%20lobby%2C%20dramatic%20lighting%20with%20warm%20amber%20tones%2C%20cinematic%20noir%20aesthetic%2C%20high%20contrast%20shadows%2C%20editorial%20style%2C%20dark%20background%20with%20golden%20accents%2C%20mysterious%20atmosphere%2C%20suspenseful%20mood%2C%20professional%20photography%20quality%2C%20subtle%20grain%20texture%2C%20no%20text%20visible%20on%20screen&width=800&height=1000&seq=gossip-hero-01&orientation=portrait',
    date: '2026-07-05',
    views: 1280000,
    comments: 45600,
    tag: '🔥 爆',
    featured: true,
  },
  {
    id: '2',
    title: '知名带货网红直播间翻车，产品质量问题被当场揭穿',
    excerpt: '千万粉丝带货网红在直播中推销某品牌保健品，被专业打假人当场指出成分造假。品牌方紧急下架商品，网红连夜发道歉声明...',
    category: '网红翻车',
    categorySlug: 'influencer-fails',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20live%20streaming%20studio%20setup%20with%20bright%20ring%20lights%20and%20product%20display%20table%2C%20chaotic%20scene%20with%20scattered%20cosmetic%20products%2C%20warm%20studio%20lighting%2C%20cinematic%20composition%2C%20modern%20streaming%20equipment%20visible%2C%20dramatic%20shadows%20and%20highlights%2C%20dark%20moody%20atmosphere%2C%20editorial%20photography%20style%2C%20professional%20quality%2C%20no%20identifiable%20faces&width=800&height=600&seq=gossip-article-02&orientation=landscape',
    date: '2026-07-04',
    views: 986000,
    comments: 32100,
    tag: '💥 炸',
  },
  {
    id: '3',
    title: '某女星前男友爆料恋爱细节，转账记录聊天截图全部实锤',
    excerpt: '深夜一篇长文引爆全网，男方晒出大量聊天记录和转账凭证，曝光该女星在恋爱期间的种种行为。粉丝集体脱粉，工作室紧急公关...',
    category: '明星八卦',
    categorySlug: 'star-gossip',
    imageUrl: 'https://readdy.ai/api/search-image?query=Smartphone%20lying%20on%20a%20dark%20wooden%20desk%20displaying%20a%20chat%20conversation%20screen%20with%20warm%20ambient%20light%2C%20dramatic%20side%20lighting%2C%20cinematic%20noir%20style%2C%20mysterious%20atmosphere%2C%20dark%20background%20with%20subtle%20bokeh%20effect%2C%20high%20contrast%2C%20editorial%20photography%2C%20professional%20quality%2C%20warm%20golden%20tones%2C%20no%20readable%20text%20on%20screen&width=800&height=600&seq=gossip-article-03&orientation=landscape',
    date: '2026-07-03',
    views: 1560000,
    comments: 67800,
    tag: '🍉 大瓜',
  },
  {
    id: '4',
    title: '某综艺选手被曝学历造假，名校光环竟是团队包装',
    excerpt: '网友扒出某热播综艺人气选手的真实学历与节目中宣传严重不符，所谓名校毕业实为成人教育。节目组回应称不知情，选手已暂停一切活动...',
    category: '网红翻车',
    categorySlug: 'influencer-fails',
    imageUrl: 'https://readdy.ai/api/search-image?query=Graduation%20cap%20and%20diploma%20scattered%20on%20a%20dark%20surface%20under%20dramatic%20spotlight%2C%20one%20diploma%20partially%20torn%2C%20mysterious%20and%20dramatic%20atmosphere%2C%20cinematic%20lighting%20with%20strong%20shadows%2C%20warm%20amber%20and%20deep%20brown%20tones%2C%20editorial%20concept%20photography%2C%20high%20contrast%2C%20professional%20quality&width=800&height=600&seq=gossip-article-04&orientation=landscape',
    date: '2026-07-02',
    views: 892000,
    comments: 28900,
    tag: '📰 新',
  },
  {
    id: '5',
    title: '娱乐圈又一对神仙眷侣离婚，第三者身份引发全网猜测',
    excerpt: '结婚仅两年的某明星夫妇官宣离婚，声明中称"和平分手"，但知情人爆料实为第三者插足。网友化身侦探，挖出疑似小三的身份线索...',
    category: '明星八卦',
    categorySlug: 'star-gossip',
    imageUrl: 'https://readdy.ai/api/search-image?query=Two%20wedding%20rings%20placed%20separately%20on%20a%20dark%20reflective%20surface%20with%20a%20visible%20crack%20between%20them%2C%20dramatic%20side%20lighting%20creating%20long%20shadows%2C%20cinematic%20noir%20style%2C%20warm%20golden%20and%20deep%20shadow%20tones%2C%20emotional%20atmosphere%2C%20editorial%20photography%2C%20high%20contrast%2C%20professional%20quality&width=800&height=600&seq=gossip-article-05&orientation=landscape',
    date: '2026-07-01',
    views: 2100000,
    comments: 89300,
    tag: '🔥 爆',
  },
];

export const categoryCards = [
  {
    id: 'star-gossip',
    name: '明星八卦',
    icon: 'ri-star-smile-line',
    count: 12860,
    description: '顶流明星恋情、婚姻、丑闻等一手爆料',
    color: 'bg-primary-500',
    lightColor: 'bg-primary-100',
    textColor: 'text-primary-600',
  },
  {
    id: 'influencer-fails',
    name: '网红翻车',
    icon: 'ri-alert-line',
    count: 9540,
    description: '带货翻车、人设崩塌、虚假宣传实锤',
    color: 'bg-accent-500',
    lightColor: 'bg-accent-100',
    textColor: 'text-accent-700',
  },
  {
    id: 'edgy-content',
    name: '擦边吃瓜',
    icon: 'ri-fire-line',
    count: 7320,
    description: '擦边内容聚合，最劲爆的娱乐圈边缘瓜',
    color: 'bg-primary-600',
    lightColor: 'bg-primary-100',
    textColor: 'text-primary-700',
  },
  {
    id: 'classic',
    name: '经典大瓜',
    icon: 'ri-archive-line',
    count: 5680,
    description: '历年经典大事件回顾，吃瓜吃到饱',
    color: 'bg-accent-600',
    lightColor: 'bg-accent-100',
    textColor: 'text-accent-800',
  },
];

export const hotArticles = [
  {
    id: '6',
    title: '小某书顶流博主被扒前期黑历史，老粉纷纷脱粉回踩',
    excerpt: '拥有300万粉丝的小某书顶流美妆博主被昔日好友曝光早期整容前后对比照片，人设瞬间崩塌。大批老粉在评论区表示失望，粉丝数一夜之间暴跌数十万...',
    category: '网红翻车',
    categorySlug: 'influencer-fails',
    date: '2026-07-05',
    views: 654000,
    comments: 18700,
    tag: '💥 炸',
    imageUrl: 'https://readdy.ai/api/search-image?query=Smartphone%20displaying%20social%20media%20app%20with%20negative%20comments%20flooding%20the%20screen%2C%20dark%20ambient%20background%2C%20warm%20dramatic%20lighting%2C%20cinematic%20style%2C%20high%20contrast%2C%20editorial%20photography%2C%20modern%20minimal%20composition%2C%20professional%20quality%2C%20no%20readable%20text&width=400&height=300&seq=gossip-hot-01&orientation=landscape',
  },
  {
    id: '7',
    title: '某知名导演被多名女演员联合举报，警方已介入调查',
    excerpt: '三位女演员联合向警方报案，指控某知名导演在片场存在不当行为。事件迅速发酵，多位圈内人士发声支持举报者。该导演名下多家公司股权已被冻结...',
    category: '明星八卦',
    categorySlug: 'star-gossip',
    date: '2026-07-04',
    views: 1890000,
    comments: 92100,
    tag: '🔥 爆',
    imageUrl: 'https://readdy.ai/api/search-image?query=Police%20car%20lights%20reflecting%20on%20a%20wet%20city%20street%20at%20night%2C%20dramatic%20red%20and%20blue%20reflections%20on%20dark%20pavement%2C%20cinematic%20noir%20atmosphere%2C%20mysterious%20mood%2C%20rainy%20night%20scene%2C%20editorial%20photography%20style%2C%20high%20contrast%2C%20professional%20quality&width=400&height=300&seq=gossip-hot-02&orientation=landscape',
  },
  {
    id: '8',
    title: '某综艺节目录制现场突发意外，选手情绪崩溃罢录',
    excerpt: '热门音乐选秀节目录制中途发生意外，一名选手因不满评委打分当场爆发，与评委发生激烈争吵后愤然离场。节目组紧急暂停录制，该期节目恐将重新剪辑...',
    category: '明星八卦',
    categorySlug: 'star-gossip',
    date: '2026-07-03',
    views: 1120000,
    comments: 45600,
    tag: '🍉 大瓜',
    imageUrl: 'https://readdy.ai/api/search-image?query=Empty%20TV%20studio%20stage%20with%20scattered%20scripts%20and%20overturned%20chair%2C%20dramatic%20spotlight%20casting%20long%20shadows%2C%20chaotic%20atmosphere%2C%20warm%20theatrical%20lighting%2C%20cinematic%20composition%2C%20dark%20audience%20area%2C%20editorial%20photography%2C%20professional%20quality&width=400&height=300&seq=gossip-hot-03&orientation=landscape',
  },
  {
    id: '9',
    title: '某品牌代言人深夜发文解约，品牌方回应引更大争议',
    excerpt: '某国际品牌中国区代言人深夜发布解约声明，称品牌方存在歧视行为。品牌方随后回应否认指控并反诉违约，双方各执一词引发网友激烈站队...',
    category: '明星八卦',
    categorySlug: 'star-gossip',
    date: '2026-07-02',
    views: 876000,
    comments: 33200,
    tag: '📰 新',
    imageUrl: 'https://readdy.ai/api/search-image?query=Torn%20contract%20papers%20scattered%20on%20a%20dark%20marble%20desk%2C%20dramatic%20side%20lighting%2C%20cinematic%20noir%20style%2C%20warm%20amber%20highlights%2C%20business%20drama%20atmosphere%2C%20editorial%20photography%2C%20high%20contrast%2C%20professional%20quality&width=400&height=300&seq=gossip-hot-04&orientation=landscape',
  },
  {
    id: '10',
    title: '某选秀节目被曝黑幕，淘汰名单提前泄露与最终结果一致',
    excerpt: '网友在节目播出前三天晒出完整淘汰名单，播出后与结果分毫不差。节目组被质疑内定选手，大量观众在官微留言要求退票。主办方至今未做出正式回应...',
    category: '网红翻车',
    categorySlug: 'influencer-fails',
    date: '2026-07-01',
    views: 1450000,
    comments: 56700,
    tag: '💥 炸',
    imageUrl: 'https://readdy.ai/api/search-image?query=Envelope%20marked%20confidential%20leaking%20from%20a%20briefcase%20on%20a%20dark%20desk%2C%20dramatic%20spotlight%2C%20mysterious%20corporate%20atmosphere%2C%20cinematic%20lighting%20with%20warm%20tones%2C%20high%20contrast%20shadows%2C%20editorial%20style%2C%20professional%20photography%20quality&width=400&height=300&seq=gossip-hot-05&orientation=landscape',
  },
  {
    id: '11',
    title: '某女网红涉嫌偷税漏税被查，补缴金额高达千万级别',
    excerpt: '税务部门通报某知名带货女主播涉嫌偷逃个人所得税，金额高达1200万元。该网红名下多家公司被列入经营异常名录，直播间遭平台暂时封禁...',
    category: '网红翻车',
    categorySlug: 'influencer-fails',
    date: '2026-06-30',
    views: 2340000,
    comments: 102500,
    tag: '🔥 爆',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stack%20of%20official%20tax%20documents%20with%20red%20stamps%20on%20a%20dark%20wooden%20desk%2C%20dramatic%20lighting%2C%20warm%20amber%20and%20deep%20brown%20tones%2C%20cinematic%20atmosphere%2C%20editorial%20photography%2C%20high%20contrast%2C%20professional%20quality&width=400&height=300&seq=gossip-hot-06&orientation=landscape',
  },
  {
    id: '12',
    title: '某知名女主播私密视频外泄，工作室称已报警处理',
    excerpt: '一段疑似某知名女主播的私密视频在社交平台疯传，工作室火速发布声明否认并称已向警方报案。但眼尖网友发现视频中的多处细节与该主播高度吻合...',
    category: '擦边吃瓜',
    categorySlug: 'edgy-content',
    date: '2026-07-06',
    views: 3450000,
    comments: 156800,
    tag: '🔥 爆',
    imageUrl: 'https://readdy.ai/api/search-image?query=Smartphone%20screen%20glowing%20in%20a%20completely%20dark%20room%2C%20mysterious%20dramatic%20atmosphere%2C%20warm%20amber%20light%20reflecting%20on%20a%20face%2C%20cinematic%20noir%20style%2C%20high%20contrast%2C%20intense%20mood%2C%20editorial%20photography%2C%20professional%20quality%2C%20dark%20shadows%2C%20suspenseful%20composition&width=400&height=300&seq=gossip-edgy-01&orientation=landscape',
  },
  {
    id: '13',
    title: '娱乐圈某大佬饭局视频曝光，多名女星疑似陪酒',
    excerpt: '一段在某高级私房菜馆拍摄的视频显示，多位知名女星与某娱乐圈大佬共进晚餐，席间举止亲密。视频拍摄者称此为行业常态，引发网友对娱乐圈潜规则的广泛讨论...',
    category: '擦边吃瓜',
    categorySlug: 'edgy-content',
    date: '2026-07-05',
    views: 2870000,
    comments: 134200,
    tag: '🍉 大瓜',
    imageUrl: 'https://readdy.ai/api/search-image?query=Luxurious%20private%20dining%20room%20with%20warm%20ambient%20lighting%2C%20empty%20round%20table%20with%20fine%20china%20and%20wine%20glasses%2C%20dramatic%20shadows%2C%20mysterious%20atmosphere%2C%20cinematic%20composition%2C%20warm%20golden%20and%20deep%20burgundy%20tones%2C%20editorial%20photography%2C%20high%20contrast%2C%20professional%20quality&width=400&height=300&seq=gossip-edgy-02&orientation=landscape',
  },
  {
    id: '14',
    title: '某女团成员被曝与已婚富豪交往，聊天记录尺度惊人',
    excerpt: '自称是某富豪妻子的网友晒出大量聊天截图，指控某当红女团成员破坏其家庭。聊天内容尺度极大，涉及金钱往来和私密话题。该成员粉丝后援会已宣布暂停应援活动...',
    category: '擦边吃瓜',
    categorySlug: 'edgy-content',
    date: '2026-07-03',
    views: 4120000,
    comments: 198500,
    tag: '🔥 爆',
    imageUrl: 'https://readdy.ai/api/search-image?query=Two%20luxury%20designer%20handbags%20placed%20apart%20on%20a%20dark%20reflective%20marble%20surface%2C%20dramatic%20side%20lighting%2C%20cinematic%20noir%20aesthetic%2C%20warm%20golden%20highlights%20and%20deep%20shadows%2C%20emotional%20drama%20atmosphere%2C%20editorial%20style%2C%20high%20contrast%2C%20professional%20photography%20quality&width=400&height=300&seq=gossip-edgy-03&orientation=landscape',
  },
  {
    id: '15',
    title: '2024年度经典回顾：某顶流塌房全事件时间线整理',
    excerpt: '从暧昧绯闻到实锤曝光，从粉丝洗白到官方封杀——我们为你完整梳理2024年最轰动的顶流塌房事件。76页PDF证据、23位知情人爆料、历时183天的完整追踪...',
    category: '经典大瓜',
    categorySlug: 'classic',
    date: '2026-01-15',
    views: 8500000,
    comments: 345000,
    tag: '🏆 经典',
    imageUrl: 'https://readdy.ai/api/search-image?query=Old%20newspaper%20clippings%20and%20vintage%20photographs%20scattered%20on%20an%20aged%20wooden%20desk%2C%20dramatic%20warm%20lighting%20from%20a%20single%20desk%20lamp%2C%20nostalgic%20atmosphere%2C%20warm%20sepia%20tones%2C%20investigative%20journalism%20aesthetic%2C%20editorial%20photography%2C%20high%20detail%2C%20professional%20quality&width=400&height=300&seq=gossip-classic-01&orientation=landscape',
  },
  {
    id: '16',
    title: '2023年娱乐圈大地震：那些年我们追过的塌房明星',
    excerpt: '2023年堪称娱乐圈"塌房元年"，从年初到年末，共有17位一线明星因各种原因翻车。本文为你盘点那些曾经红极一时、如今却销声匿迹的明星们...',
    category: '经典大瓜',
    categorySlug: 'classic',
    date: '2025-12-20',
    views: 7200000,
    comments: 287000,
    tag: '🏆 经典',
    imageUrl: 'https://readdy.ai/api/search-image?query=Collection%20of%20broken%20vintage%20cameras%20and%20scattered%20film%20negatives%20on%20a%20dark%20surface%2C%20dramatic%20spotlight%20effect%2C%20nostalgic%20cinematic%20atmosphere%2C%20warm%20amber%20and%20sepia%20tones%2C%20melancholic%20mood%2C%20editorial%20photography%2C%20high%20contrast%2C%20professional%20quality&width=400&height=300&seq=gossip-classic-02&orientation=landscape',
  },
  {
    id: '17',
    title: '某网红偷税案二审宣判：维持原判补缴税款+罚款共计3800万',
    excerpt: '备受关注的某千万粉丝网红偷税案二审结果出炉，法院驳回上诉维持原判。该网红需补缴税款及罚款合计3800余万元。其名下公司已进入破产清算程序，多个代言品牌宣布解约...',
    category: '经典大瓜',
    categorySlug: 'classic',
    date: '2025-08-10',
    views: 5600000,
    comments: 212000,
    tag: '🏆 经典',
    imageUrl: 'https://readdy.ai/api/search-image?query=Gavel%20resting%20on%20a%20stack%20of%20legal%20documents%20on%20a%20dark%20wooden%20desk%2C%20dramatic%20courtroom%20lighting%2C%20warm%20amber%20and%20deep%20brown%20tones%2C%20cinematic%20atmosphere%2C%20justice%20theme%2C%20editorial%20photography%2C%20high%20contrast%2C%20professional%20quality&width=400&height=300&seq=gossip-classic-03&orientation=landscape',
  },
];

export const hotSearchTerms = [
  '顶流男星深夜密会',
  '网红带货翻车实锤',
  '女星前男友爆料',
  '综艺学历造假',
  '明星夫妻离婚真相',
  '导演被联合举报',
  '选秀黑幕曝光',
  '千万网红偷税漏税',
  '代言人深夜解约',
  '综艺录制意外',
];

export const testimonials = [
  {
    id: 't1',
    name: '瓜田里的猹',
    role: '资深吃瓜群众',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20minimalist%20avatar%20with%20warm%20red%20and%20orange%20gradient%20circle%20on%20dark%20background%2C%20modern%20flat%20design%2C%20simple%20geometric%20style%2C%20clean%20aesthetic%2C%20professional%20quality&width=80&height=80&seq=gossip-avatar-01&orientation=squarish',
    quote: '吃瓜网真的是我每天蹲守的宝藏网站！明星八卦更新速度全网第一，而且料都特别实锤，不是那种标题党。每次打开都有新瓜，根本停不下来！',
    rating: 5,
  },
  {
    id: 't2',
    name: '八卦小能手',
    role: '微博大V',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20minimalist%20avatar%20with%20warm%20amber%20gradient%20circle%20on%20dark%20background%2C%20modern%20flat%20design%2C%20simple%20geometric%20style%2C%20clean%20aesthetic%2C%20professional%20quality&width=80&height=80&seq=gossip-avatar-02&orientation=squarish',
    quote: '作为自媒体人，我经常从吃瓜网获取第一手素材。这里的信息真实度高，更新快，而且分类很清晰。已经推荐给身边所有爱吃瓜的朋友了！',
    rating: 5,
  },
  {
    id: 't3',
    name: '吃瓜不吐籽',
    role: '忠实用户',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20minimalist%20avatar%20with%20warm%20coral%20gradient%20circle%20on%20dark%20background%2C%20modern%20flat%20design%2C%20simple%20geometric%20style%2C%20clean%20aesthetic%2C%20professional%20quality&width=80&height=80&seq=gossip-avatar-03&orientation=squarish',
    quote: '从吃瓜网建站初期就在用了，看着它越来越完善。最爱的就是爆料大赛这个板块，普通人也能参与进来，感觉自己是娱乐圈的一份子！',
    rating: 5,
  },
  {
    id: 't4',
    name: '娱乐侦察兵',
    role: '贴吧吧主',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20minimalist%20avatar%20with%20warm%20ochre%20gradient%20circle%20on%20dark%20background%2C%20modern%20flat%20design%2C%20simple%20geometric%20style%2C%20clean%20aesthetic%2C%20professional%20quality&width=80&height=80&seq=gossip-avatar-04&orientation=squarish',
    quote: '网站加载速度巨快，界面也很清爽没有乱七八糟的广告。内容质量一直在提升，爆料大赛还真的出了好几个全网爆款瓜，太强了！',
    rating: 5,
  },
  {
    id: 't5',
    name: '深夜吃瓜人',
    role: '豆瓣小组组长',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20minimalist%20avatar%20with%20warm%20terracotta%20gradient%20circle%20on%20dark%20background%2C%20modern%20flat%20design%2C%20simple%20geometric%20style%2C%20clean%20aesthetic%2C%20professional%20quality&width=80&height=80&seq=gossip-avatar-05&orientation=squarish',
    quote: '吃瓜网的擦边内容区真的是我见过最敢做的板块了！很多其他平台不敢发的内容这里都能看到，而且都是实锤，不是捕风捉影的谣言。',
    rating: 4,
  },
];

export const faqItems = [
  {
    question: '吃瓜网的内容都是真实的吗？',
    answer: '吃瓜网致力于提供真实、可靠的爆料内容。我们的内容来源包括用户投稿、专业狗仔爆料、以及多方交叉验证的信息。每篇爆料文章都会标注信息来源和可信度评级，让用户自行判断。我们坚决反对造谣和恶意诽谤，对于不实信息会及时删除并澄清。',
  },
  {
    question: '如何参与爆料大赛？',
    answer: '参与爆料大赛非常简单！只需点击页面上的"立即爆料"按钮，填写你的爆料内容和相关证据（如有），提交后我们的审核团队会在24小时内进行审核。通过审核的爆料将自动参与当月爆料大赛，点赞数和评论数最高的爆料者将获得丰厚奖励！',
  },
  {
    question: '吃瓜网收费吗？',
    answer: '完全不收费！吃瓜网是一个免费的娱乐资讯聚合平台，所有内容均可免费浏览。我们承诺永久免费，不会设置付费墙或会员专属内容。网站通过广告和品牌合作维持运营，不影响用户体验。',
  },
  {
    question: '为什么有些内容被删除了？',
    answer: '内容删除通常出于以下几种原因：1）被证实为不实信息；2）涉及当事人隐私权投诉；3）违反相关法律法规要求。我们重视内容合规性，也尊重当事人的合法权益。如您发现内容被误删，可以通过"联系我们"页面进行申诉。',
  },
];